import { ReactElement } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../Base.constants';
import useFetchUrlMapping from '../../hooks/urlMapping/useFetchUrlMapping';
import { isMail } from '../../utils/articleUtils';

const ABSOLUTE_PATH_REGEX =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\\+.~#?&/=]*)$/;
const DEFAULT_ROUTE = ROUTES.feed;

const openNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener, noreferrer');
};

interface LocationProps {
  state?: {
    from?: string;
  };
}

const Redirect = (): ReactElement | null => {
  const [searchParams] = useSearchParams();
  const url = searchParams.get('url');
  const isOpenInNewTab = searchParams.get('newTab') === 'true';
  const { data: newUrl, isLoading } = useFetchUrlMapping(url || '');
  const location = useLocation() as LocationProps;
  const previousRoute = location.state?.from;
  const previousUrl = previousRoute ? new URL(previousRoute) : null;
  const internalRoute = previousUrl ? previousUrl.pathname + previousUrl.search : DEFAULT_ROUTE;

  if (isLoading) {
    return null;
  }

  if (newUrl) {
    const isAbsolutePath = ABSOLUTE_PATH_REGEX.test(newUrl);
    if (isAbsolutePath || isMail(newUrl)) {
      openNewTab(newUrl);
      return <Navigate to={internalRoute} replace />;
    }

    if (isOpenInNewTab) {
      openNewTab(newUrl);
      return <Navigate to={internalRoute} replace />;
    }
    window.location.replace(newUrl);
    return null;
  }

  return <Navigate to={ROUTES.notFound} replace />;
};

export default Redirect;
